export default {
  // 設定頁面
  PickGameTitle: "挑人轉盤-遊戲設定",
  candidatesLabel: "候選名字設定",
  candidatesPlaceholder: "輸入候選名字，並以逗號(,)分隔，按下Enter新增項目，最大候選數為20人，超過10人則隨機挑選",
  clearSettings: "清空設定",
  saveSettings: "儲存設定", 
  candidateExists: "候選人已存在",
  maxCandidates: "最多只能新增20位候選人",
  
  // 遊戲頁面
  gameTitle: "挑人轉盤",
  spinWheel: "轉動轉盤",
  winner: "獲勝者",
  spinAgain: "再轉一次",
  backToSettings: "返回設定"
}